import { render, staticRenderFns } from "./NewMethod.vue?vue&type=template&id=0cf6a5fa&scoped=true&"
import script from "./NewMethod.vue?vue&type=script&lang=js&"
export * from "./NewMethod.vue?vue&type=script&lang=js&"
import style0 from "./NewMethod.vue?vue&type=style&index=0&id=0cf6a5fa&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf6a5fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow,VSwitch,VTextField})
